/**
 * Enotna logika za alt/caption besedila slik.
 *
 * Pravila:
 * - besedilo se vedno začne z dejanskim naslovom izdelka oz. imenom trgovine,
 * - vsaka slika v galeriji dobi svoj opisni dodatek (nikoli podvojen alt),
 * - besedila so v slovenščini in brez polnil tipa "slika1.jpg".
 */

const GALLERY_ASPECTS = [
  "podroben pogled",
  "pogled od blizu",
  "pogled s strani",
  "detajl izdelave",
  "prikaz uporabe",
  "pogled od zadaj",
  "material in tekstura",
] as const;

function clean(value: string | null | undefined, fallback: string) {
  const v = (value ?? "").replace(/\s+/g, " ").trim();
  return v.length > 0 ? v : fallback;
}

/** Alt/caption za sliko izdelka. `index` je 0 za glavno sliko. */
export function productImageAlt(
  title: string | null | undefined,
  storeName: string | null | undefined,
  index: number,
  total = 1,
) {
  const name = clean(title, "Izdelek v spletnem nakupovalnem središču kupish.si");
  const store = clean(storeName, null as unknown as string) || "";
  const by = store ? `, prodajalec ${store}` : "";
  if (index <= 0) return `${name}${by}`;
  const aspect = GALLERY_ASPECTS[(index - 1) % GALLERY_ASPECTS.length];
  const counter = total > 1 ? ` (${index + 1}/${total})` : "";
  return `${name} – ${aspect}${by}${counter}`;
}

/** Daljši caption za image sitemap; nikoli enak drugi sliki iste strani. */
export function productImageCaption(
  title: string | null | undefined,
  storeName: string | null | undefined,
  index: number,
  total = 1,
) {
  return `${productImageAlt(title, storeName, index, total)}.`;
}

export type VendorImageKind = "logo" | "banner";

/** Alt/caption za profilno ali naslovno sliko trgovine. */
export function vendorImageAlt(
  storeName: string | null | undefined,
  kind: VendorImageKind,
  city?: string | null,
) {
  const store = clean(storeName, "Prodajalec");
  const place = clean(city, "");
  const where = place ? ` iz kraja ${place}` : "";
  return kind === "logo"
    ? `Profilna slika trgovine ${store}${where}`
    : `Naslovna slika trgovine ${store}${where}`;
}

export function vendorImageTitle(storeName: string | null | undefined, kind: VendorImageKind) {
  const store = clean(storeName, "Prodajalec");
  return kind === "logo" ? `${store} – profilna slika` : `${store} – naslovna slika trgovine`;
}
